import React from "react";
import PropTypes from "prop-types";
import { Hidden } from "@material-ui/core";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";

/**
 * Menu de pestañas del modulo, manejado por datos: recibe las opciones y las
 * pinta. Agregar una pestaña es agregar una entrada en catalogo.js, no
 * duplicar el bloque de escritorio y el de movil.
 *
 * Las clases (item_selec, item_modulo, item_selec_app) son las del CSS global
 * del proyecto; se conservan tal cual para no romper el estilo.
 */
const claseItem = (codigo, seleccion, sufijo = "") =>
  codigo === seleccion ? `item_selec${sufijo}` : "item_modulo";

const MenuModulo = ({ opciones, seleccion, onSeleccionar }) => (
  <div>
    <Hidden xsDown>
      <div className="menu_modulo">
        {opciones.map(({ codigo, label, Icono }) => (
          <BottomNavigation
            key={codigo}
            showLabels
            className={claseItem(codigo, seleccion)}
            onClick={() => onSeleccionar(codigo)}
          >
            <BottomNavigationAction label={label} icon={<Icono />} />
          </BottomNavigation>
        ))}
      </div>
    </Hidden>

    <Hidden smUp>
      <div className="menu_modulo_app">
        <BottomNavigation showLabels>
          {opciones.map(({ codigo, label, Icono }) => (
            <BottomNavigationAction
              key={codigo}
              label={label}
              icon={<Icono />}
              className={claseItem(codigo, seleccion, "_app")}
              onClick={() => onSeleccionar(codigo)}
            />
          ))}
        </BottomNavigation>
      </div>
    </Hidden>
  </div>
);

MenuModulo.propTypes = {
  opciones: PropTypes.arrayOf(
    PropTypes.shape({
      codigo: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      Icono: PropTypes.elementType.isRequired,
    }),
  ).isRequired,
  seleccion: PropTypes.string.isRequired,
  onSeleccionar: PropTypes.func.isRequired,
};

export default MenuModulo;
